import { Flex } from 'antd';
import { TickFillIcon } from '../../common/all-icons/custom-icons';

const EmailRecieved = () => {
  return (
    <Flex vertical justify="start" align="start" gap={8} className={'authWrap'}>
      <Flex align="center" gap={15}>
        <div className="mb-2" style={{ color: 'var(--user-main-green)' }}>
          <TickFillIcon />
        </div>
        <h2 className="heading-text">Email Sent</h2>
      </Flex>
      <h5 className="subheading-text">
        Please check your email inbox for the verification link to reset your password!
      </h5>
    </Flex>
  );
};

export default EmailRecieved;
